import { Injectable, signal } from '@angular/core';
import { Network } from '@capacitor/network';
import * as Sentry from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private readonly _isOnline = signal(true);
  readonly isOnline = this._isOnline.asReadonly();

  constructor() {
    Network.getStatus().then((status) => this.update(status.connected));
    Network.addListener('networkStatusChange', (status) => this.update(status.connected));
  }

  private update(connected: boolean): void {
    this._isOnline.set(connected);
    Sentry.setTag('device.online', String(connected));
    Sentry.addBreadcrumb({
      category: 'connectivity',
      message: connected ? 'Device came back online' : 'Device went offline',
      level: connected ? 'info' : 'warning',
    });
  }
}
